import { Box, Stack } from "@mui/material";
import ComingSoonFeature from "../components/common/ComingSoonFeature";

const Changelog = () => {
  return (
    <Box>
      <Stack spacing={4}>
        {/* Calendar Feature */}
        <Box>
          <ComingSoonFeature
            featureName="CHANGELOG"
            skeletonType="list"
            description="Get to know what's new and improved in our latest updates!"
            height={650}
          />
        </Box>
      </Stack>
    </Box>
  );
};

export default Changelog;
